import { v7 as uuidv7, parse as uuidParse } from "uuid";

const generateUuid = (): string => {
  const uuid = uuidv7();
  const bytes = uuidParse(uuid);

  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export default generateUuid;
